import * as React from "react";
import { Anchor } from "../../typography/anchor/anchor.mjs";
import { Container } from "../../container/container.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { HeaderDropdown } from "../header-dropdown/header-dropdown.mjs";
import { HeaderSegment } from "../header-segment/header-segment.mjs";
const HeaderEmployee = (props) => {
  const { environment = "live", segment, actions, openSection, dropdownContainer, onActionClick } = props;
  const BEM = () => {
    const classArray = ["header__employee", "header__employee--".concat(environment)];
    return classArray.join(" ");
  };
  const getSegmentColor = () => {
    switch (environment) {
      case "test":
        return "employee-test";
      case "dev":
        return "employee-dev";
      case "live":
      default:
        return "employee";
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: BEM() }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement("div", { className: "header__top-inner" }, /* @__PURE__ */ React.createElement("div", { className: "header__top-left" }, segment && /* @__PURE__ */ React.createElement(HeaderSegment, { ...segment, color: getSegmentColor() })), /* @__PURE__ */ React.createElement("div", { className: "header__top-right" }, /* @__PURE__ */ React.createElement(HeaderEmployeeActions, { items: actions.items, currentSection: openSection, dropdownContainer, onActionClick })))));
};
const HeaderEmployeeActions = React.memo((props) => {
  const { currentSection, dropdownContainer, items, onActionClick } = props;
  return /* @__PURE__ */ React.createElement("ul", { className: "header__employee-actions" }, items.map((item) => {
    return /* @__PURE__ */ React.createElement(
      HeaderEmployeeActionsItem,
      {
        ...item,
        dropdownContainer,
        isCurrent: currentSection === item.id,
        onToggle: () => onActionClick(item.id),
        key: item.id
      }
    );
  }));
});
const HeaderEmployeeActionsItem = React.memo((props) => {
  const {
    dropdownContainer,
    dropdownContent,
    dropdownSize = "small",
    dropdownPadding,
    dropdownLabelledBy,
    hideLabel = false,
    icon,
    isCurrent = false,
    label,
    labelClassName,
    showArrow,
    onToggle,
    ...rest
  } = props;
  const labelBEM = () => {
    const classArray = ["header__employee-item-label"];
    if (labelClassName) {
      classArray.push(labelClassName);
    }
    return classArray.join(" ");
  };
  const buttonBEM = () => {
    const classArray = ["header__employee-button"];
    if (hideLabel) {
      classArray.push("header__employee-button--hide-label");
    }
    if (icon) {
      classArray.push("header__employee-button--with-icon");
    }
    if (isCurrent) {
      classArray.push("is-current");
    }
    return classArray.join(" ");
  };
  const anchor = /* @__PURE__ */ React.createElement(Anchor, { isUnderlined: false, ...rest, className: buttonBEM() }, icon && /* @__PURE__ */ React.createElement(Icon, { modifiers: icon, className: "header__employee-icon" }), /* @__PURE__ */ React.createElement("span", { className: labelBEM() }, label), showArrow && /* @__PURE__ */ React.createElement(Icon, { modifiers: "#arrow-down", className: "header__employee-arrow-icon" }));
  return /* @__PURE__ */ React.createElement("li", { className: "header__employee-item" }, dropdownContent && dropdownContainer ? /* @__PURE__ */ React.createElement(
    HeaderDropdown,
    {
      asModal: true,
      offsetY: 0,
      size: dropdownSize,
      padding: dropdownPadding,
      isShown: isCurrent,
      onToggle,
      reference: anchor,
      container: dropdownContainer,
      "aria-labelledby": dropdownLabelledBy
    },
    dropdownContent
  ) : anchor);
});
export {
  HeaderEmployee
};
